import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cb304cf4 = () => interopDefault(import('../pages/about-ideas-suggestions/index.vue' /* webpackChunkName: "pages/about-ideas-suggestions/index" */))
const _6132a90c = () => interopDefault(import('../pages/all-star/index.vue' /* webpackChunkName: "pages/all-star/index" */))
const _310e6897 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _056cf904 = () => interopDefault(import('../pages/cookies-policy/index.vue' /* webpackChunkName: "pages/cookies-policy/index" */))
const _0a68765e = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _0fb84d2e = () => interopDefault(import('../pages/handbook/index.js' /* webpackChunkName: "pages/handbook/index" */))
const _db5d6440 = () => interopDefault(import('../pages/insight/index.vue' /* webpackChunkName: "pages/insight/index" */))
const _8cc507d0 = () => interopDefault(import('../pages/ipad/index.vue' /* webpackChunkName: "pages/ipad/index" */))
const _dc145338 = () => interopDefault(import('../pages/pocket/index.vue' /* webpackChunkName: "pages/pocket/index" */))
const _632ad8b6 = () => interopDefault(import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _78449196 = () => interopDefault(import('../pages/prize/index.js' /* webpackChunkName: "pages/prize/index" */))
const _3122bebd = () => interopDefault(import('../pages/sitemap/index.vue' /* webpackChunkName: "pages/sitemap/index" */))
const _77100d52 = () => interopDefault(import('../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _28ef8c68 = () => interopDefault(import('../pages/terms-conditions/index.vue' /* webpackChunkName: "pages/terms-conditions/index" */))
const _396277d0 = () => interopDefault(import('../pages/app/privacy-policy.vue' /* webpackChunkName: "pages/app/privacy-policy" */))
const _4682848a = () => interopDefault(import('../pages/ipad/3d.vue' /* webpackChunkName: "pages/ipad/3d" */))
const _b6602ed8 = () => interopDefault(import('../pages/ipad/accessibility.vue' /* webpackChunkName: "pages/ipad/accessibility" */))
const _656f091a = () => interopDefault(import('../pages/ipad/beta.vue' /* webpackChunkName: "pages/ipad/beta" */))
const _1d1c222e = () => interopDefault(import('../pages/ipad/brushes.vue' /* webpackChunkName: "pages/ipad/brushes" */))
const _5fd1d229 = () => interopDefault(import('../pages/ipad/color.vue' /* webpackChunkName: "pages/ipad/color" */))
const _416d5538 = () => interopDefault(import('../pages/ipad/cutting-edge.vue' /* webpackChunkName: "pages/ipad/cutting-edge" */))
const _6a19188e = () => interopDefault(import('../pages/ipad/preview.vue' /* webpackChunkName: "pages/ipad/preview" */))
const _9f51f6e2 = () => interopDefault(import('../pages/ipad/superpowers.vue' /* webpackChunkName: "pages/ipad/superpowers" */))
const _39326b41 = () => interopDefault(import('../pages/ipad/video.vue' /* webpackChunkName: "pages/ipad/video" */))
const _50615d70 = () => interopDefault(import('../pages/ipad/whats-new.vue' /* webpackChunkName: "pages/ipad/whats-new" */))
const _3e79d459 = () => interopDefault(import('../pages/pocket/coming-soon.vue' /* webpackChunkName: "pages/pocket/coming-soon" */))
const _86ccb4d8 = () => interopDefault(import('../pages/pocket/whats-new.vue' /* webpackChunkName: "pages/pocket/whats-new" */))
const _4926f3ce = () => interopDefault(import('../pages/prize/2019.vue' /* webpackChunkName: "pages/prize/2019" */))
const _4a5cf8e4 = () => interopDefault(import('../pages/prize/2020.vue' /* webpackChunkName: "pages/prize/2020" */))
const _a98f8962 = () => interopDefault(import('../pages/handbook/_product/index.vue' /* webpackChunkName: "pages/handbook/_product/index" */))
const _1d79e236 = () => interopDefault(import('../pages/insight/_year/_slug.vue' /* webpackChunkName: "pages/insight/_year/_slug" */))
const _1fe28248 = () => interopDefault(import('../pages/handbook/_product/_.vue' /* webpackChunkName: "pages/handbook/_product/_" */))
const _d1a09f42 = () => interopDefault(import('../pages/handbook/_product/_/index.vue' /* webpackChunkName: "pages/handbook/_product/_/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-ideas-suggestions",
    component: _cb304cf4,
    name: "about-ideas-suggestions___en___default"
  }, {
    path: "/all-star",
    component: _6132a90c,
    name: "all-star___en___default"
  }, {
    path: "/cn",
    component: _310e6897,
    name: "index___cn"
  }, {
    path: "/cookies-policy",
    component: _056cf904,
    name: "cookies-policy___en___default"
  }, {
    path: "/en",
    component: _310e6897,
    name: "index___en"
  }, {
    path: "/faq",
    component: _0a68765e,
    name: "faq___en___default"
  }, {
    path: "/handbook",
    component: _0fb84d2e,
    name: "handbook___en___default"
  }, {
    path: "/insight",
    component: _db5d6440,
    name: "insight___en___default"
  }, {
    path: "/ipad",
    component: _8cc507d0,
    name: "ipad___en___default"
  }, {
    path: "/jp",
    component: _310e6897,
    name: "index___jp"
  }, {
    path: "/pocket",
    component: _dc145338,
    name: "pocket___en___default"
  }, {
    path: "/privacy-policy",
    component: _632ad8b6,
    name: "privacy-policy___en___default"
  }, {
    path: "/prize",
    component: _78449196,
    name: "prize___en___default"
  }, {
    path: "/sitemap",
    component: _3122bebd,
    name: "sitemap___en___default"
  }, {
    path: "/support",
    component: _77100d52,
    name: "support___en___default"
  }, {
    path: "/terms-conditions",
    component: _28ef8c68,
    name: "terms-conditions___en___default"
  }, {
    path: "/app/privacy-policy",
    component: _396277d0,
    name: "app-privacy-policy___en___default"
  }, {
    path: "/cn/about-ideas-suggestions",
    component: _cb304cf4,
    name: "about-ideas-suggestions___cn"
  }, {
    path: "/cn/all-star",
    component: _6132a90c,
    name: "all-star___cn"
  }, {
    path: "/cn/cookies-policy",
    component: _056cf904,
    name: "cookies-policy___cn"
  }, {
    path: "/cn/faq",
    component: _0a68765e,
    name: "faq___cn"
  }, {
    path: "/cn/handbook",
    component: _0fb84d2e,
    name: "handbook___cn"
  }, {
    path: "/cn/insight",
    component: _db5d6440,
    name: "insight___cn"
  }, {
    path: "/cn/ipad",
    component: _8cc507d0,
    name: "ipad___cn"
  }, {
    path: "/cn/pocket",
    component: _dc145338,
    name: "pocket___cn"
  }, {
    path: "/cn/privacy-policy",
    component: _632ad8b6,
    name: "privacy-policy___cn"
  }, {
    path: "/cn/prize",
    component: _78449196,
    name: "prize___cn"
  }, {
    path: "/cn/sitemap",
    component: _3122bebd,
    name: "sitemap___cn"
  }, {
    path: "/cn/support",
    component: _77100d52,
    name: "support___cn"
  }, {
    path: "/cn/terms-conditions",
    component: _28ef8c68,
    name: "terms-conditions___cn"
  }, {
    path: "/en/about-ideas-suggestions",
    component: _cb304cf4,
    name: "about-ideas-suggestions___en"
  }, {
    path: "/en/all-star",
    component: _6132a90c,
    name: "all-star___en"
  }, {
    path: "/en/cookies-policy",
    component: _056cf904,
    name: "cookies-policy___en"
  }, {
    path: "/en/faq",
    component: _0a68765e,
    name: "faq___en"
  }, {
    path: "/en/handbook",
    component: _0fb84d2e,
    name: "handbook___en"
  }, {
    path: "/en/insight",
    component: _db5d6440,
    name: "insight___en"
  }, {
    path: "/en/ipad",
    component: _8cc507d0,
    name: "ipad___en"
  }, {
    path: "/en/pocket",
    component: _dc145338,
    name: "pocket___en"
  }, {
    path: "/en/privacy-policy",
    component: _632ad8b6,
    name: "privacy-policy___en"
  }, {
    path: "/en/prize",
    component: _78449196,
    name: "prize___en"
  }, {
    path: "/en/sitemap",
    component: _3122bebd,
    name: "sitemap___en"
  }, {
    path: "/en/support",
    component: _77100d52,
    name: "support___en"
  }, {
    path: "/en/terms-conditions",
    component: _28ef8c68,
    name: "terms-conditions___en"
  }, {
    path: "/ipad/3d",
    component: _4682848a,
    name: "ipad-3d___en___default"
  }, {
    path: "/ipad/accessibility",
    component: _b6602ed8,
    name: "ipad-accessibility___en___default"
  }, {
    path: "/ipad/beta",
    component: _656f091a,
    name: "ipad-beta___en___default"
  }, {
    path: "/ipad/brushes",
    component: _1d1c222e,
    name: "ipad-brushes___en___default"
  }, {
    path: "/ipad/color",
    component: _5fd1d229,
    name: "ipad-color___en___default"
  }, {
    path: "/ipad/cutting-edge",
    component: _416d5538,
    name: "ipad-cutting-edge___en___default"
  }, {
    path: "/ipad/preview",
    component: _6a19188e,
    name: "ipad-preview___en___default"
  }, {
    path: "/ipad/superpowers",
    component: _9f51f6e2,
    name: "ipad-superpowers___en___default"
  }, {
    path: "/ipad/video",
    component: _39326b41,
    name: "ipad-video___en___default"
  }, {
    path: "/ipad/whats-new",
    component: _50615d70,
    name: "ipad-whats-new___en___default"
  }, {
    path: "/jp/about-ideas-suggestions",
    component: _cb304cf4,
    name: "about-ideas-suggestions___jp"
  }, {
    path: "/jp/all-star",
    component: _6132a90c,
    name: "all-star___jp"
  }, {
    path: "/jp/cookies-policy",
    component: _056cf904,
    name: "cookies-policy___jp"
  }, {
    path: "/jp/faq",
    component: _0a68765e,
    name: "faq___jp"
  }, {
    path: "/jp/handbook",
    component: _0fb84d2e,
    name: "handbook___jp"
  }, {
    path: "/jp/insight",
    component: _db5d6440,
    name: "insight___jp"
  }, {
    path: "/jp/ipad",
    component: _8cc507d0,
    name: "ipad___jp"
  }, {
    path: "/jp/pocket",
    component: _dc145338,
    name: "pocket___jp"
  }, {
    path: "/jp/privacy-policy",
    component: _632ad8b6,
    name: "privacy-policy___jp"
  }, {
    path: "/jp/prize",
    component: _78449196,
    name: "prize___jp"
  }, {
    path: "/jp/sitemap",
    component: _3122bebd,
    name: "sitemap___jp"
  }, {
    path: "/jp/support",
    component: _77100d52,
    name: "support___jp"
  }, {
    path: "/jp/terms-conditions",
    component: _28ef8c68,
    name: "terms-conditions___jp"
  }, {
    path: "/pocket/coming-soon",
    component: _3e79d459,
    name: "pocket-coming-soon___en___default"
  }, {
    path: "/pocket/whats-new",
    component: _86ccb4d8,
    name: "pocket-whats-new___en___default"
  }, {
    path: "/prize/2019",
    component: _4926f3ce,
    name: "prize-2019___en___default"
  }, {
    path: "/prize/2020",
    component: _4a5cf8e4,
    name: "prize-2020___en___default"
  }, {
    path: "/cn/app/privacy-policy",
    component: _396277d0,
    name: "app-privacy-policy___cn"
  }, {
    path: "/cn/ipad/3d",
    component: _4682848a,
    name: "ipad-3d___cn"
  }, {
    path: "/cn/ipad/accessibility",
    component: _b6602ed8,
    name: "ipad-accessibility___cn"
  }, {
    path: "/cn/ipad/beta",
    component: _656f091a,
    name: "ipad-beta___cn"
  }, {
    path: "/cn/ipad/brushes",
    component: _1d1c222e,
    name: "ipad-brushes___cn"
  }, {
    path: "/cn/ipad/color",
    component: _5fd1d229,
    name: "ipad-color___cn"
  }, {
    path: "/cn/ipad/cutting-edge",
    component: _416d5538,
    name: "ipad-cutting-edge___cn"
  }, {
    path: "/cn/ipad/preview",
    component: _6a19188e,
    name: "ipad-preview___cn"
  }, {
    path: "/cn/ipad/superpowers",
    component: _9f51f6e2,
    name: "ipad-superpowers___cn"
  }, {
    path: "/cn/ipad/video",
    component: _39326b41,
    name: "ipad-video___cn"
  }, {
    path: "/cn/ipad/whats-new",
    component: _50615d70,
    name: "ipad-whats-new___cn"
  }, {
    path: "/cn/pocket/coming-soon",
    component: _3e79d459,
    name: "pocket-coming-soon___cn"
  }, {
    path: "/cn/pocket/whats-new",
    component: _86ccb4d8,
    name: "pocket-whats-new___cn"
  }, {
    path: "/cn/prize/2019",
    component: _4926f3ce,
    name: "prize-2019___cn"
  }, {
    path: "/cn/prize/2020",
    component: _4a5cf8e4,
    name: "prize-2020___cn"
  }, {
    path: "/en/app/privacy-policy",
    component: _396277d0,
    name: "app-privacy-policy___en"
  }, {
    path: "/en/ipad/3d",
    component: _4682848a,
    name: "ipad-3d___en"
  }, {
    path: "/en/ipad/accessibility",
    component: _b6602ed8,
    name: "ipad-accessibility___en"
  }, {
    path: "/en/ipad/beta",
    component: _656f091a,
    name: "ipad-beta___en"
  }, {
    path: "/en/ipad/brushes",
    component: _1d1c222e,
    name: "ipad-brushes___en"
  }, {
    path: "/en/ipad/color",
    component: _5fd1d229,
    name: "ipad-color___en"
  }, {
    path: "/en/ipad/cutting-edge",
    component: _416d5538,
    name: "ipad-cutting-edge___en"
  }, {
    path: "/en/ipad/preview",
    component: _6a19188e,
    name: "ipad-preview___en"
  }, {
    path: "/en/ipad/superpowers",
    component: _9f51f6e2,
    name: "ipad-superpowers___en"
  }, {
    path: "/en/ipad/video",
    component: _39326b41,
    name: "ipad-video___en"
  }, {
    path: "/en/ipad/whats-new",
    component: _50615d70,
    name: "ipad-whats-new___en"
  }, {
    path: "/en/pocket/coming-soon",
    component: _3e79d459,
    name: "pocket-coming-soon___en"
  }, {
    path: "/en/pocket/whats-new",
    component: _86ccb4d8,
    name: "pocket-whats-new___en"
  }, {
    path: "/en/prize/2019",
    component: _4926f3ce,
    name: "prize-2019___en"
  }, {
    path: "/en/prize/2020",
    component: _4a5cf8e4,
    name: "prize-2020___en"
  }, {
    path: "/jp/app/privacy-policy",
    component: _396277d0,
    name: "app-privacy-policy___jp"
  }, {
    path: "/jp/ipad/3d",
    component: _4682848a,
    name: "ipad-3d___jp"
  }, {
    path: "/jp/ipad/accessibility",
    component: _b6602ed8,
    name: "ipad-accessibility___jp"
  }, {
    path: "/jp/ipad/beta",
    component: _656f091a,
    name: "ipad-beta___jp"
  }, {
    path: "/jp/ipad/brushes",
    component: _1d1c222e,
    name: "ipad-brushes___jp"
  }, {
    path: "/jp/ipad/color",
    component: _5fd1d229,
    name: "ipad-color___jp"
  }, {
    path: "/jp/ipad/cutting-edge",
    component: _416d5538,
    name: "ipad-cutting-edge___jp"
  }, {
    path: "/jp/ipad/preview",
    component: _6a19188e,
    name: "ipad-preview___jp"
  }, {
    path: "/jp/ipad/superpowers",
    component: _9f51f6e2,
    name: "ipad-superpowers___jp"
  }, {
    path: "/jp/ipad/video",
    component: _39326b41,
    name: "ipad-video___jp"
  }, {
    path: "/jp/ipad/whats-new",
    component: _50615d70,
    name: "ipad-whats-new___jp"
  }, {
    path: "/jp/pocket/coming-soon",
    component: _3e79d459,
    name: "pocket-coming-soon___jp"
  }, {
    path: "/jp/pocket/whats-new",
    component: _86ccb4d8,
    name: "pocket-whats-new___jp"
  }, {
    path: "/jp/prize/2019",
    component: _4926f3ce,
    name: "prize-2019___jp"
  }, {
    path: "/jp/prize/2020",
    component: _4a5cf8e4,
    name: "prize-2020___jp"
  }, {
    path: "/cn/handbook/:product",
    component: _a98f8962,
    name: "handbook-product___cn"
  }, {
    path: "/en/handbook/:product",
    component: _a98f8962,
    name: "handbook-product___en"
  }, {
    path: "/jp/handbook/:product",
    component: _a98f8962,
    name: "handbook-product___jp"
  }, {
    path: "/cn/insight/:year/:slug?",
    component: _1d79e236,
    name: "insight-year-slug___cn"
  }, {
    path: "/en/insight/:year/:slug?",
    component: _1d79e236,
    name: "insight-year-slug___en"
  }, {
    path: "/jp/insight/:year/:slug?",
    component: _1d79e236,
    name: "insight-year-slug___jp"
  }, {
    path: "/jp/handbook/:product/*",
    component: _1fe28248,
    children: [{
      path: "",
      component: _d1a09f42,
      name: "handbook-product-all___jp"
    }]
  }, {
    path: "/cn/handbook/:product/*",
    component: _1fe28248,
    children: [{
      path: "",
      component: _d1a09f42,
      name: "handbook-product-all___cn"
    }]
  }, {
    path: "/en/handbook/:product/*",
    component: _1fe28248,
    children: [{
      path: "",
      component: _d1a09f42,
      name: "handbook-product-all___en"
    }]
  }, {
    path: "/handbook/:product",
    component: _a98f8962,
    name: "handbook-product___en___default"
  }, {
    path: "/insight/:year/:slug?",
    component: _1d79e236,
    name: "insight-year-slug___en___default"
  }, {
    path: "/handbook/:product/*",
    component: _1fe28248,
    children: [{
      path: "",
      component: _d1a09f42,
      name: "handbook-product-all___en___default"
    }]
  }, {
    path: "/",
    component: _310e6897,
    name: "index___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
